export default "__VITE_PUBLIC_ASSET__80998e9c__"